import React, { useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import InputResponsiblePerson from '@components/framework/input/InputResponsiblePerson/InputResponsiblePerson.tsx';
import { LovDTO } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  required?: boolean;
  readonly?: boolean;
  person: LovDTO;
  onChange: (responsiblePerson: LovDTO) => void;
  icon?: React.ReactElement;
}

const ResponsiblePersonTag: React.FC<ComponentProps> = ({ secured, readonly, required, person, onChange, icon }) => {
  const [internalValue, setInternalValue] = useState(person);
  const { tr } = useTranslationLgs();

  useEffect(() => setInternalValue(person), [person]);

  const renderText = (responsiblePersonId: LovDTO) => {
    return responsiblePersonId ? responsiblePersonId.name : null;
  };

  return (
    <>
      <ButtonTag
        secured={secured}
        icon={icon}
        label={tr('ResponsiblePersonTag.zodpovednaOsoba', 'Zodpovědná osoba')}
        required={required}
        readonly={readonly}
        value={renderText(person)}
        onSave={onSuccess => {
          onChange(internalValue);
          onSuccess();
        }}
        autoClose
        dataTestId="internalInfo-responsiblePerson"
      >
        <InputResponsiblePerson responsiblePerson={internalValue} onChange={setInternalValue} dataTestId="internalInfo-responsiblePersonList" />
      </ButtonTag>
    </>
  );
};

export default ResponsiblePersonTag;
